import { render } from "./CIS-Carousel.vue?vue&type=template&id=57a23d62&scoped=true"
import script from "./CIS-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-Carousel.vue?vue&type=script&lang=js"

import "./CIS-Carousel.vue?vue&type=style&index=0&id=57a23d62&lang=scss&scoped=true"
import "./CIS-Carousel.vue?vue&type=style&index=1&id=57a23d62&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a23d62"]])

export default __exports__